import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Data from "../services/Data";
import Intervals from "../services/Intervals";
import AppContainer from "./AppContainer";
import ErrorBoundary from "./Shared/ErrorBoundary";
import ClientVersionGate from "./Shared/ClientUpdate/ClientVersionGate";
// import whyDidYouUpdate from 'why-did-you-update';
import { LinkFailed } from "source/app/presentation/Routing/LinkFailed";
import ActivePanel from "./Shared/ActivePanel/ActivePanel";
import SessionGate from "./Shared/Authentication/SessionGate";
import { HasActiveClientSession } from "../services/Authentication/ClientSession";

// EnableReactProfiling();

// ReactDOM must render after the component
// it references has been loaded
// try {

const isProduction = window.location.hostname === "thisisthefinalact.com";

export const baseUrl = isProduction
    ? `https://thisisthefinalact.com/motw_client/build/production/`
    : location.href;

ReactDOM.render(
    <ClientVersionGate>
        <SessionGate><ErrorBoundary>
            <>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<AppContainer />}>
                            <Route path=":panelName">
                                <Route path=":elementId" element={<ActivePanel />} />
                                <Route index element={<ActivePanel />} />
                            </Route>
                            <Route index element={<ActivePanel />} />
                        </Route>
                        <Route path="*" element={<LinkFailed />} />
                    </Routes>
                </BrowserRouter>
            </>
        </ErrorBoundary></SessionGate>
    </ClientVersionGate>,
    document.getElementById("AppContainer")
);

// }
// catch (error) {
//     toastr.error(error.message, `Global error`, {
//         timeOut: 0,
//         extendedTimeOut: 0
//     });
//     console.error(error);
// }

// Add google workbox service worker for caching
// if ('serviceWorker' in navigator) {
// 	window.addEventListener('load', () => {
// 		navigator.serviceWorker
// 			.register('./workbox.js')
// 			.then((registration) => {
// 				console.log('SW registered: ', registration);
// 			})
// 			.catch((registrationError) => {
// 				console.log('SW registration failed: ', registrationError);
// 			});
// 	});
// }

// Enable Webpack Hot Module Reolading
if ((module as any).hot) {
    (module as any).hot.accept();
    (module as any).hot.dispose(() => {
        Intervals.Stop("refreshState");
    });
}

// Refresh state every hour
Intervals.Start({
    name: "refreshState",
    execute: () => { if (HasActiveClientSession()) void Data.Load.AllAsync(); },
    period: 60 * 60 * 1000, // every hour
});

// console.log(`Logic server URL is ${process.env.LOGIC_SERVER_URL}`)

// function EnableReactProfiling() {
//     // why-did-you-update react performance analyzer
//     console.warn('React performance analyzer why-did-you-update is enabled');
//     whyDidYouUpdate(React);
// }

export function ReloadApp() {
    location.reload();
}
